module.exports = __webpack_public_path__ + "media/images/icon__info--white-1fb133f7d7c2ffce0b31b7226fbb37ef.png";